import React from "react";
import "./Aicte_vaani.css";
import {
    Underline,
    ContentCard,
} from "../../widgets";

const AicteVaani = () => {
    // Replace this with your actual S3 image URL
    const aicteVaaniS3Image =
        "YOUR_S3_IMAGE_URL_HERE";

    return (
        <div className="aicte-vaani-page">

            {/* ================================
          PAGE HEADER
      ================================= */}
            <section className="aicte-vaani-header">
                <h1 className="aicte-vaani-title">
                    AICTE VAANI 2026–27
                </h1>

                <h2 className="aicte-vaani-subtitle">
                    Three Days National Seminar on Space and Defence
                </h2>
            </section>


            {/* ================================
    POSTERS
================================= */}

            <div className="aicte-vaani-posters">

                {/* First Poster */}
                <div className="aicte-vaani-poster-item">
                    <img
                        className="aicte-vaani-poster-image"
                        src="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/aivte+vaani1.webp"
                        alt="AICTE VAANI 2026-27 Seminar Poster"
                    />
                </div>

                {/* Second Poster */}
                <div className="aicte-vaani-poster-item">
                    <img
                        className="aicte-vaani-poster-image"
                        src="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/aicte+vaani+2.webp"
                        alt="AICTE VAANI Seminar"
                    />
                </div>

            </div>


            {/* ================================
          CONTENT
      ================================= */}
            <section className="aicte-vaani-content">


                {/* -------- ENGLISH CONTENT -------- */}
                <div className="aicte-vaani-content-block">



                    <Underline heading="About the Seminar" />

                    <p className="aicte-vaani-paragraph">
                        This three-day national seminar is sponsored by AICTE
                        under the thrust area of Advanced Computing, scheme VAANI,
                        and is titled <strong>“Space and Defence”</strong>, with
                        the theme <strong>“Exploring Technology ♦️ Ensuring
                            Security ♦️ Shaping the Future.”</strong>
                    </p>

                    <p className="aicte-vaani-paragraph">
                        The seminar offers an in-depth exploration of emerging
                        technologies and strategic developments in the space and
                        defence sectors, covering key areas such as satellites,
                        launch vehicles, space communication and navigation,
                        defence electronics, surveillance and sensing technologies,
                        and emerging defence systems.
                    </p>

                    <p className="aicte-vaani-paragraph">
                        Expert speakers will provide insights into fundamental
                        concepts, technological advancements, practical
                        applications, and future trends shaping India’s space and
                        defence capabilities.
                    </p>

                    <p className="aicte-vaani-paragraph">
                        The sessions will be conducted primarily in
                        <strong> Tamil</strong>, supporting the AICTE VAANI
                        initiative of promoting technical education and knowledge
                        dissemination in the mother tongue.
                    </p>

                    <p className="aicte-vaani-paragraph">
                        Designed for postgraduate students, research scholars,
                        faculty members, and technology enthusiasts, the seminar
                        aims to highlight the role of advanced science and
                        engineering in strengthening national security, enabling
                        space exploration, fostering indigenous technological
                        innovation, and shaping the future of India’s strategic
                        capabilities.
                    </p>

                </div>


                {/* -------- TAMIL CONTENT -------- */}
                <div className="aicte-vaani-content-block aicte-vaani-tamil-block">

                    <Underline heading="கருத்தரங்கம் குறித்து" />

                    <p className="aicte-vaani-paragraph aicte-vaani-tamil-text">
                        இந்த மூன்று நாள் தேசிய அளவிலான கருத்தரங்கம்,
                        AICTE-யின் <strong>Advanced Computing</strong> துறையின்
                        கீழ், <strong>VAANI திட்டத்தின்</strong> வாயிலாக
                        ஆதரிக்கப்படுகிறது. <strong>“விண்வெளி மற்றும்
                            பாதுகாப்பு”</strong> என்ற தலைப்பில்,
                        <strong> “தொழில்நுட்பத்தை ஆராய்வோம் ♦️ பாதுகாப்பை
                            உறுதி செய்வோம் ♦️ எதிர்காலத்தை வடிவமைப்போம்”</strong>
                        என்ற கருப்பொருளை மையமாகக் கொண்டு இக்கருத்தரங்கம்
                        நடைபெறுகிறது.
                    </p>

                    <p className="aicte-vaani-paragraph aicte-vaani-tamil-text">
                        விண்வெளி மற்றும் பாதுகாப்புத் துறைகளில் உருவாகி வரும்
                        நவீன தொழில்நுட்பங்கள் மற்றும் மூலோபாய முன்னேற்றங்கள்
                        குறித்து இக்கருத்தரங்கம் விரிவான புரிதலை வழங்குகிறது.
                        செயற்கைக்கோள்கள், ஏவுகணை வாகனங்கள், விண்வெளித்
                        தகவல்தொடர்பு மற்றும் வழிகாட்டுதல், பாதுகாப்பு
                        மின்னணுவியல், கண்காணிப்பு மற்றும் உணர்திறன்
                        தொழில்நுட்பங்கள், வளர்ந்து வரும் பாதுகாப்பு அமைப்புகள்
                        உள்ளிட்ட முக்கிய துறைகள் இதில் இடம்பெறுகின்றன.
                    </p>

                    <p className="aicte-vaani-paragraph aicte-vaani-tamil-text">
                        துறைசார் வல்லுநர்கள், அடிப்படைக் கோட்பாடுகள்,
                        தொழில்நுட்ப முன்னேற்றங்கள், நடைமுறைப் பயன்பாடுகள் மற்றும்
                        இந்தியாவின் விண்வெளி மற்றும் பாதுகாப்புத் திறன்களை
                        வடிவமைக்கும் எதிர்காலப் போக்குகள் குறித்து தங்களது
                        நிபுணத்துவத்தைப் பகிர்ந்து கொள்வார்கள்.
                    </p>

                    <p className="aicte-vaani-paragraph aicte-vaani-tamil-text">
                        <strong>
                            தாய்மொழியில் தொழில்நுட்பக் கல்வி மற்றும்
                            அறிவுப் பரவலை ஊக்குவிக்கும் AICTE VAANI
                            முன்முயற்சிக்கு
                        </strong>{" "}
                        ஆதரவளிக்கும் வகையில், கருத்தரங்கின் அமர்வுகள்
                        முதன்மையாக <strong>தமிழில்</strong> நடைபெறும்.
                    </p>

                    <p className="aicte-vaani-paragraph aicte-vaani-tamil-text">
                        முதுநிலை மாணவர்கள், ஆராய்ச்சி மாணவர்கள், ஆசிரியர்கள்
                        மற்றும் தொழில்நுட்ப ஆர்வலர்களுக்காக வடிவமைக்கப்பட்டுள்ள
                        இக்கருத்தரங்கம், தேசியப் பாதுகாப்பை வலுப்படுத்துதல்,
                        விண்வெளி ஆய்வை முன்னெடுத்தல், உள்நாட்டு தொழில்நுட்பப்
                        புதுமைகளை ஊக்குவித்தல் மற்றும் இந்தியாவின் மூலோபாயத்
                        திறன்களின் எதிர்காலத்தை வடிவமைத்தல் ஆகியவற்றில்
                        மேம்பட்ட அறிவியல் மற்றும் பொறியியல் தொழில்நுட்பங்களின்
                        முக்கியத்துவத்தை எடுத்துரைக்கும்.
                    </p>

                </div>

            </section>

            {/* =================================================
    YOUTUBE VIDEO
================================================= */}

            <section className="aicte-vaani-video-section">

                <Underline heading="Seminar Video" />

                <div className="aicte-vaani-video-container">

                    <iframe
                        src="https://www.youtube.com/embed/PoIA5m7kXpQ"
                        title="AICTE VAANI 2026-27 Seminar Video"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>

                </div>

            </section>


            {/* ================================
    PDF SECTION
================================= */}

            <div className="aicte-vaani-pdf-section">

                <Underline heading="Seminar Brochure" />

                <div className="aicte-vaani-pdf-holder">

                    <div className="aicte-vaani-pdf-card">
                        <ContentCard
                            heading="AICTE VAANI Participant NOC"
                            pdf="https://drive.google.com/file/d/1zL9CJdbnn2hDwx8AsGLxWGYI4_gbHKpC/view?usp=sharing"
                        />
                    </div>

                    <div className="aicte-vaani-pdf-card">
                        <ContentCard
                            heading="Procedure for Registration"
                            pdf="https://drive.google.com/file/d/1q12oIXl70qzEnBJ5jzCHri0rJnLR0sZf/view?usp=sharing"
                        />
                    </div>

                </div>

            </div>




            {/* ================================
          REGISTER BUTTON
      ================================= */}
            <section className="aicte-vaani-register-section">

                <a
                    className="aicte-vaani-register-button"
                    href="https://atalacademy.aicte.gov.in/signup"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Register Now
                </a>

            </section>

        </div>
    );
};

export default AicteVaani;